export default __webpack_public_path__ + "static/media/05AW2SEP66.4cebce1b.jpg";